<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" @click-left="$router.go(-1)" />
    <div class="mt-header-nav">
      <div class="kong"></div>
      <van-cell-group>
        <!-- <van-field
          v-model="form.MemberCardType"
          readonly
          required
          label="卡类："
          placeholder="点击此处选择"
          @click="showMemberCardType"
        /> -->
        <form-select
          label="卡类"
          :required="true"
          textKey="Name"
          v-model="form.MemberCardTypeId"
          :columns="selectData.MemberType"
        ></form-select>
      </van-cell-group>

      <!-- <van-cell-group v-if="!EditStatus">
        <form-select
          label="状态"
          :required="true"
          v-model="form.MemberCardStatus"
          :columns="selectData.MmemberStatus"
        ></form-select>
      </van-cell-group> -->

      <div class="kong"></div>

      <van-cell-group>
        <van-field
          v-model="form.Name"
          required
          label="姓名："
          placeholder="请输入会员姓名"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field label="性别：">
          <template #input>
            <van-radio-group v-model="form.Sex" style="display:flex;">
              <van-radio name="0">男</van-radio>
              <van-radio name="1" style="margin-left:24px;">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.Phone"
          required
          type="tel"
          label="手机号："
          placeholder="请输入手机号码"
        />
      </van-cell-group>

      <div class="kong"></div>
      <van-cell-group>
        <!-- <van-field
          v-model="form.IDTypeDesc"
          readonly
          label="证件类型："
          placeholder="点击此处选择"
          @click="showIDType"
        /> -->
        <form-select
          label="证件类型"
          v-model="form.IDType"
          :columns="selectData.IDType"
        ></form-select>
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.IDNo"
          label="证件号码："
          :placeholder="'请输入证件号码'"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.BirthDate"
          readonly
          label="出生日期："
          placeholder="点击此处选择"
          @click="showSelectDate"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.Country"
          label="国籍："
          :placeholder="'请输入国籍'"
        />
      </van-cell-group>
      <div class="kong"></div>
      <van-cell-group>
        <van-field
          v-model="form.MemberRemark"
          rows="2"
          autosize
          label="备注信息："
          type="textarea"
          maxlength="200"
          placeholder="请输入备注信息"
          show-word-limit
        />
      </van-cell-group>

      <div class="box" style="margin-top:0.5rem">
        <van-button type="info" block :disabled="disabled" @click="onSubmit"
          >确认保存</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Cell,
  CellGroup,
  NoticeBar,
  Button,
  Toast,
  Notify,
  RadioGroup,
  Radio,
} from "vant";
import {
  getMemberInfo,
  getMemberTypeList,
  addMember,
  editMember,
} from "@/api/member.js";
import { getSelectData } from "@/api/common.js";
import { checkPhone } from "@/utils/common.js";
import formSelect from "@/components/form-select";
// import SelectPicker from "@/components/select-picker/function";
import DateTimePicker from "@/components/date-time-picker/function";
export default {
  name: "addMember",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    formSelect,
  },
  data() {
    return {
      title: "添加会员",
      selectData: {
        MemberType: [],
      },
      disabled: false,
      CardData: {},
      form: {
        Id: 0,
        MemberCardTypeId: "",
        MemberCardType: "",
        MemberCardStatus: "1",
        Status: "1",
        Sex: "",
        IDTypeDesc: "",
        IDType: "",
        BirthDate: "",
        IDNo: "",
        MemberRemark: "",
        EditStatus: false,
      },
    };
  },
  created() {
    this.init();
    this.getSelectData();
  },
  methods: {
    init() {
      this.form.Id = this.$route.query.Id;
      if (this.form.Id) {
        this.title = "编辑会员";
        this.EditStatus = true;
        this.getInfo();
      } else {
        this.EditStatus = false;
        this.title = "添加会员";
      }
    },

    getInfo() {
      //查询会员明细
      getMemberInfo({
        Id: this.$route.query.Id,
      }).then(res => {
        this.form = res.Data;
        this.form.MemberCardTypeId = res.Data.MemberCardTypeId;
        this.form.MemberCardType = res.Data.Name;
        this.form.MemberCardStatus = res.Data.Status;
        this.form.MemberRemark = res.Data.MemberRemark;
      });
      // this.$post("Contact_Info", { Id: this.form.Id })
      //   .then(res => {
      //     console.log(res);
      //     this.form = res.Data;
      //   })
      //   .catch(err => {
      //     console.log(123);
      //   });
    },
    //获取下拉数据
    getSelectData() {
      //获取卡类
      getMemberTypeList({
        PageIndex: 0,
        PageSize: 1000,
      }).then(res => {
        this.selectData.MemberType = res.Data.Datas;
      });
      //获取会员状态
      getSelectData({
        Types: "MemberCardStatus,idType",
      }).then(res => {
        this.selectData.MmemberStatus = res.Data.MemberCardStatus;
        this.selectData.IDType = res.Data.idType;
      });
    },
    //显示卡类选择器
    // showMemberCardType() {
    //   const _this = this;
    //   SelectPicker({
    //     valueKey: "Name",
    //     columns: this.selectData.MemberType,
    //     defaultValue: this.form.MemberCardTypeId,
    //     change: data => {
    //       console.log(data);

    //       _this.form.MemberCardTypeId = data.Id;
    //       _this.form.MemberCardType = data.Name;
    //     }
    //   });
    // },
    //显示状态选择器
    // showMemberCardStatus() {
    //   const _this = this;
    //   SelectPicker({
    //     columns: this.selectData.MmemberStatus,
    //     defaultValue: this.form.MemberCardTypeId,
    //     change: data => {
    //       console.log(data);
    //       _this.form.Status = data.Id;
    //       _this.form.MemberCardStatus = data.Text;
    //     }
    //   });
    // },
    //显示证件类型选择器
    // showIDType() {
    //   const _this = this;
    //   SelectPicker({
    //     columns: this.selectData.IDType,
    //     defaultValue: this.form.IDType,
    //     change: data => {
    //       _this.form.IDType = data.Id;
    //       _this.form.IDTypeDesc = data.Text;
    //     }
    //   });
    // },
    showSelectDate() {
      const _this = this;
      const time = this.form.BirthDate ? this.form.BirthDate : "2000-01-01";
      DateTimePicker({
        value: time,
        format: "YYYY-MM-DD",
        change: date => {
          _this.form.BirthDate = date;
        },
      });
    },

    onSubmit() {
      //验证
      const verifyRes = this.verifyForm();
      if (verifyRes === false) {
        return false;
      }
      const json = {
        memberInfo: {
          Name: this.form.Name,
          Sex: this.form.Sex,
          Phone: this.form.Phone,
          IDType: this.form.IDType,
          IDNo: this.form.IDNo,
          BirthDate: this.form.BirthDate,
          Country: this.form.Country,
          MemberRemark: this.form.MemberRemark,
        },
        memberCard: {
          MemberCardTypeId: this.form.MemberCardTypeId,
          Status: this.form.Status,
          CardNo: this.form.CardNo ? this.form.CardNo : this.form.Phone,
        },
      };
      if (this.EditStatus) {
        const param = {
          Id: this.form.Id,
          Name: this.form.Name,
          Sex: this.form.Sex,
          Phone: this.form.Phone,
          IDType: this.form.IDType,
          IDNo: this.form.IDNo,
          BirthDate: this.form.BirthDate,
          Country: this.form.Country,
          MemberRemark: this.form.MemberRemark,
          MemberCardTypeId: this.form.MemberCardTypeId,
          CardNo: this.form.CardNo,
          Status: this.form.Status,
        };
        editMember(param).then(() => {
          Toast.success("修改成功");
          this.$router.push({
            name: "memberInfo",
            query: {
              Id: this.form.Id,
            },
          });
        });
      } else {
        addMember(json).then(() => {
          Toast.success("保存成功");
          let form = {};
          for (const key in this.form) {
            form[key] = "";
          }
          this.form = form;
        });
      }
    },
    verifyForm() {
      let verifyFields = ["MemberCardTypeId", "Name", "Phone"];
      // if (!this.EditStatus) {
      //   verifyFields = verifyFields.concat("MemberCardStatus");
      // }
      let is = false;
      for (let i = 0; i < verifyFields.length; i++) {
        const item = verifyFields[i];
        if (!this.form[item]) {
          is = true;
        }
      }
      if (is) {
        Notify("带*号必填，请完善信息！");
        return false;
      }
      const validPhone = checkPhone(this.form.Phone);
      if (!validPhone) {
        Notify("手机号码格式不对！");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-field__label {
  width: 1.9rem;
}
</style>
